import { durationInHours } from "hhn-commons";
import { FileWithPath } from "react-dropzone";

export const getAudioDuration = async (file: FileWithPath): Promise<string> => {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.src = URL.createObjectURL(file);

    audio.addEventListener("loadedmetadata", () => {
      URL.revokeObjectURL(audio.src);
      resolve(durationInHours(audio.duration));
    });

    audio.addEventListener("error", error => {
      URL.revokeObjectURL(audio.src);
      reject(error);
    });
  });
};
